import { v4 as uuidv4 } from "uuid";

const sendGTMEvent = (data) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

const getOrCreateDeviceId = () => {
  if (typeof window === "undefined") {
    return undefined;
  }

  try {
    const existingDeviceId = localStorage.getItem("device_id");
    if (existingDeviceId) return existingDeviceId;

    const newDeviceId = uuidv4();
    localStorage.setItem("device_id", newDeviceId);
    return newDeviceId;
  } catch {
    return uuidv4();
  }
};

const getPincodeValue = () => {
  if (typeof window === "undefined") {
    return undefined;
  }

  try {
    return localStorage.getItem("pincode");
  } catch {
    return undefined;
  }
};

export const pushGtmEvent = ({
  event_name = null,
  event_action = null,
  event_value = null,
  pincode = null,
  device_id = null,
  homeowner_contact_number = null,
  homeowner_name = null,
  homeowner_site_address = null,
  contractor_id = null,
  contractor_name = null,
  contractor_phone_number = null,
  contractor_profile_id = null,
  project_photo_count = null,
  utm_source = null,
  utm_medium = null,
  utm_campaign = null,
  utm_content = null,
  utm_term = null,
}) => {
  // 1. Map all possible properties.
  // If a property isn't passed in the arguments, it defaults to null.
  const eventProperties = {
    event_name,
    event_action,
    event_value,
    event_timestamp: new Date().toISOString(),
    pincode: pincode || getPincodeValue(),
    device_id: device_id || getOrCreateDeviceId(),
    homeowner_contact_number,
    homeowner_name,
    homeowner_site_address,
    contractor_id,
    contractor_name,
    contractor_phone_number,
    contractor_profile_id,
    project_photo_count,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term,
  };

  // 2. DEBUG: Log the full object to see the nulls being sent
  // console.log("Pushing to GTM:", eventProperties);

  // 3. Send to GTM
  // We DO NOT filter the object here. Sending 'null' is what clears the previous GTM state.
  sendGTMEvent({
    event: "fevicol-multiply-event",
    ...eventProperties,
  });
};
